




















import { Vue, Component, Prop } from 'vue-property-decorator'
import CardDeMetrica from './CardDeMetrica.vue'
import type { PerfilDoCliente } from '@/models'
import {
	montarMetricasDeAtendimento,
	montarMetricasPorTipoDeVenda,
	montarMetricasPrincipais,
	textoDoVendedorPredominante,
} from '@/shareds/painel-do-cliente-shareds'

@Component({
	components: {
		CardDeMetrica,
	},
})
export default class MetricasDoCliente extends Vue {
	@Prop({ type: Object, default: null }) perfil!: PerfilDoCliente | null

	get vendedorPredominante() {
		return textoDoVendedorPredominante(this.perfil?.vendedorPredominanteNome)
	}

	get cardsPrincipais() {
		return montarMetricasPrincipais(this.perfil)
	}

	get cardsPorTipoDeVenda() {
		return montarMetricasPorTipoDeVenda(this.perfil?.vendasPorTipo)
	}

	get cardsDeAtendimento() {
		return montarMetricasDeAtendimento(this.perfil?.vendasPorTipo)
	}
}
